import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const submitToStripe = ({ userId, contentIds }) =>
  call(websocketFetch, 'set_stripe_identification', {
    user_id: userId,
    front_content_id: contentIds[0],
    back_content_id: contentIds[1] || null,
  });
